import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import EditPageModal from './edit_page_settings'; // Import here
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
const PagesList = () => {
  const [pages, setPages] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchPages();
  }, []);

  useEffect(() => {
    const filtered = pages.filter((item) => {
      const text = searchText.toLowerCase();
      return (
        item.page_name?.toLowerCase().includes(text) ||
        item.message?.toLowerCase().includes(text)
      );
    });
    setFilteredData(filtered);
  }, [searchText, pages]);

  const fetchPages = () => {
    setLoading(true);
    DataService.getPages()
      .then((response) => {
        console.log(response)
        setPages(response.data);
        setFilteredData(response.data);
      })
      .catch((error) => {
        console.error('Failed to fetch pages:', error);
      })
      .finally(() => setLoading(false));
  };

  const handleEditClick = (page) => {
    setSelectedPage(page);
    setShowModal(true);
  };

  const handleModalSave = (updatedPage) => {
    setLoading(true)
    DataService.updatePage(updatedPage) // <-- you need to implement this in backend/API
      .then(() => {
           
        setTimeout(() => {
                    fetchPages(); // refresh list

        }, 3000);
      })
      .catch((err) => {
         setLoading(false)
        console.error('Failed to update page:', err);
      })
      .finally(() => setShowModal(false));
  };

  const columns = [
    //{ name: 'ID', selector: row => row.id, sortable: true, width: '80px' },
    {
  name: 'Page Name',
  selector: row => {
    if (row.page_name === 'Payment Button') {
      return 'Pay with card (Button)';
    }
    return row.page_name;
  },
  sortable: true
},
    {
      name: 'Message',
      selector: row =>   <div dangerouslySetInnerHTML={{ __html: row.message }} />
,
      grow: 3,
      wrap: true,
    },
    {
      name: 'Status',
      selector: row => row.is_enabled,
      cell: row => (
        <span className={`badge white ${row.is_enabled ? 'bg-secondary' : 'bg-success'}`}>
        {row.page_name === 'Appointment Booking' || row.page_name === 'Payment Button' || row.page_name === 'Pay Later Button' ? (row.is_enabled ? 'Disabled' : 'Enabled') : 'Not Applicable'}
        </span>
      ),
      sortable: true,
    },
   {
  name: 'Action',
  cell: row => (
    <FontAwesomeIcon
      icon={faEdit}
      className="text-primary"
      style={{ cursor: 'pointer', fontSize: '14px' }}
      onClick={() => handleEditClick(row)}
    />
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
}
  ];

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Page Settings</h4>
        </div>
        <input
          type="text"
          placeholder="Search by page or message"
          className="form-control mb-3 px-3"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          striped
          responsive
          noHeader
        />
      </div>
{showModal && (
    <EditPageModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        page={selectedPage}
        onSave={handleModalSave}
      />
)}
      
    </>
  );
};

export default PagesList;
